/**
 * Click "burst" feedback for the frosted quick-nav pills (Home/Catalog/
 * Contact) -- both the drawer's (snippets/header-drawer.liquid,
 * .tng-quicknav-item) and the desktop nav bar's
 * (blocks/_header-menu.liquid, .tng-desktop-quicknav-item). Hover/press
 * -scale/active state are pure CSS; this only adds the radial gold burst
 * expanding from the exact tap point.
 *
 * Matches two distinct classes rather than sharing one between drawer
 * and desktop: they were sharing `.tng-quicknav-item` at first purely so
 * this listener would pick up both, but that also made the drawer's
 * vertical-pill CSS rule (`li > a.tng-quicknav-item:only-child`) and the
 * desktop's horizontal-pill rule collide at equal specificity -- the
 * desktop pill was silently inheriting the drawer's border-radius/
 * padding/font-size instead of its own. Keeping the classes separate for
 * styling and only sharing them here, at the JS layer, avoids that.
 *
 * Uses event delegation on document instead of binding to the links
 * directly: Shopify's header-drawer/header-menu custom elements re-render
 * their subtree after first paint, which would detach listeners bound to
 * the original (soon-replaced) link nodes (same reasoning as
 * tng-menu-carousel.js).
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  document.addEventListener('click', function (ev) {
    if (prefersReducedMotion()) return;

    var link = ev.target.closest('.tng-quicknav-item, .tng-desktop-quicknav-item');
    if (!link) return;

    var rect = link.getBoundingClientRect();
    var burst = document.createElement('span');
    burst.className = 'tng-quicknav-burst';
    burst.style.setProperty('--tng-x', ev.clientX - rect.left + 'px');
    burst.style.setProperty('--tng-y', ev.clientY - rect.top + 'px');
    link.appendChild(burst);
    burst.addEventListener('animationend', function () {
      burst.remove();
    });
  });
})();
